export const copyTextToClipboard = async (value) => {
  if (!navigator?.clipboard?.writeText) {
    throw new Error('Clipboard API unavailable');
  }

  await navigator.clipboard.writeText(value);
};
